import { SET_ACCOUNT_DATA } from "../reducers/actionType";

export function setAccountData(data) {
  return {
    type: SET_ACCOUNT_DATA,
    payload: data,
  };
}
